import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './routes/Root';
import React, { Suspense, lazy  } from "react"; 
import ScrollToTop from './helpers/ScrollToTop';
import HomePage from './pages/Home';
import { Helmet } from 'react-helmet';

function App() {

  
  const currentYear = new Date().getFullYear();
  const metaContent = `User Experience (UX) Design Agenturen ${currentYear} - Go Digital`;

  const ImprimirPage = lazy(() => import('./pages/Imprimir'));
  const ProteccionDeLosDatos = lazy(() => import('./pages/ProteccionDeLosDatos'));

  return (
    <>
     <Helmet>
    <title>{metaContent}</title>
    <meta name="keywords" content="Agencias de Diseño UX, Agencias de Experiencia de Usuario, Análisis de Mercado, Agencias de UI, Diseñadores UX, Alemania, Berlín, Hamburgo, Frankfurt, Múnich, Agencias de Investigación de Usuario, Consultoría de Experiencia de Usuario, Diseño de Interfaz de Usuario, Consultores de Usabilidad" />
    <meta name="description" content="Resultados de la clasificación de las mejores agencias de diseño UX en Alemania, iniciativa apoyada por el Ministerio Federal de Economía y Protección del Clima" />
    <meta name="title" content={metaContent} />
</Helmet>
<Router>
    <ScrollToTop />
    <Routes>
        <Route path='/' element={<Layout />}>
            <Route index element={
                <HomePage />
            } />
            <Route path='/imprimir' element={
                <Suspense fallback={<div>cargando</div>}>
                    <ImprimirPage />
                </Suspense>
            } />
            <Route path='/proteccion-de-los-datos' element={
                <Suspense fallback={<div>cargando</div>}>
                    <ProteccionDeLosDatos />
                </Suspense>
             
              } />
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
